import { httpService } from './http'
const videoRoute = 'handle-video/'

export const videoService = {
    createVideo,
    deleteVideo,
    editVideo,
    getVideos,
    getArchivedVideos,
    getVideoAndTeam,
    saveThumbnails,
}

async function getVideos(teamId) {
    const videos = await httpService.post(videoRoute + 'get-videos', { teamId })
    return videos
}

async function getArchivedVideos(teamId) {
    const videos = await httpService.post(videoRoute + 'get-archive', { teamId })
    return videos
}

async function getVideoAndTeam(videoId) {
    const data = await httpService.get(videoRoute + 'get-video-and-team/' + videoId)
    return data
}

async function createVideo(video, teamId, nextMemberId) {
    const addedVideo = await httpService.post(videoRoute + 'create-video', { video, teamId, nextMemberId })
    return addedVideo
}

async function deleteVideo(videoId, teamId, reason) {
    const deletedId = await httpService.delete(videoRoute + 'delete-video', { videoId, teamId, reason })
    return deletedId
}

async function editVideo({ partToEdit, videoId, teamId, edit, nextSteps }) {
    const editedVideo = await httpService.put(videoRoute + 'edit-video', { partToEdit, videoId, teamId, edit, nextSteps })
    return editedVideo
}

async function saveThumbnails(thumbnails, videoId, teamId, markAsSubmitted = false) {
    const submittedThumbnails = await httpService.put(videoRoute + 'save-thumbnails', { thumbnails, videoId, teamId, markAsSubmitted })
    return submittedThumbnails
}